class FilmFeatureSlideshow extends HTMLElement {
  constructor() {
    super();

    this.filmFeatureSlide = this.querySelector('.js-film-article-slideshow');
    this.swiperSlide = this.querySelectorAll('.js-film-article-slideshow .swiper-slide');
    if(this.swiperSlide.length > 1){
      new Swiper(this.filmFeatureSlide, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          speed: 1000,
          autoHeight: false,
          // Navigation arrows
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          },
      });
    } else {
      this.filmFeatureSlide.querySelector('.swiper-button-next').classList.add('button-none');
      this.filmFeatureSlide.querySelector('.swiper-button-prev').classList.add('button-none');
      new Swiper(this.filmFeatureSlide, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          autoHeight: false,
      });
    }
  }
}
customElements.define("film-article-slideshow", FilmFeatureSlideshow)